import React, { useState, useMemo } from 'react';
import { useRaces } from '@/hooks/useRaces';
import { DEFAULT_RACE_IMAGE } from '@/config/constants';
import HomePageView from './homepage.view';

const HomePage = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const { data: upcomingRaw = [], isLoading: loadingUpcoming } = useRaces({ status: 'Upcoming' });
  const { data: pastRaw = [], isLoading: loadingPast } = useRaces({ status: 'Past' });

  const loading = loadingUpcoming || loadingPast;

  const transformRace = (race) => ({
    id: race.id,
    title: race.name,
    subtitle: '',
    location: race.location,
    organizer: race.admin?.name || 'Unknown',
    organizerId: race.adminId,
    date: race.startDate?.split('T')[0] || '',
    time: race.startDate?.split('T')[1]?.substring(0, 5) || '',
    image: DEFAULT_RACE_IMAGE,
    registrationUrl: `/events/${race.id}/register`,
    status: race.status?.toLowerCase() || 'upcoming',
    openRegistrationDate: race.openRegistrationDate?.split('T')[0] || '',
    closeRegistrationDate: race.closeRegistrationDate?.split('T')[0] || '',
    description: race.description || ''
  });

  const upcomingRaces = useMemo(() => upcomingRaw.map(transformRace), [upcomingRaw]);
  const pastRaces = useMemo(() => pastRaw.map(transformRace), [pastRaw]);

  const filterRaces = (races) => {
    if (!searchQuery) return races;
    return races.filter(
      (race) =>
        race.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        race.location.toLowerCase().includes(searchQuery.toLowerCase()) ||
        race.organizer.toLowerCase().includes(searchQuery.toLowerCase())
    );
  };

  const filteredUpcoming = filterRaces(upcomingRaces);
  const filteredPast = filterRaces(pastRaces);

  return (
    <HomePageView
      loading={loading}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      filteredUpcoming={filteredUpcoming}
      filteredPast={filteredPast}
    />
  );
};

export default HomePage;
